export default "__VITE_ASSET__DqnmlZgl__"